// extracted by mini-css-extract-plugin
module.exports = {"items":"Pagination_items__1Jdyc","item":"Pagination_item__3lt71","ellipsisItem":"Pagination_ellipsisItem__1Wm0R"};